import { defineComponent as _defineComponent } from 'vue'

import { computed, defineComponent } from "@nuxtjs/composition-api";

import { useBranchService, useFlag } from "@/composables";
import { FLAG_GET_THE_APP_BANNER, FLAG_WEB_REGISTRATION_BANNER } from "@/utils/experiments/constants";

const __default__ = defineComponent({});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'BottomBanner',
  props: {
  branchBannerFailed: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



// if branch failed & app banner is enabled show app banner

const appBannerFlag = useFlag(FLAG_GET_THE_APP_BANNER);
const registrationBannerFlag = useFlag(FLAG_WEB_REGISTRATION_BANNER);
const branch = useBranchService();

const branchFailed = computed(() => {
  return branch.initState === "error" || props.branchBannerFailed;
});

const shouldShowAppBanner = computed(() => {
  // show app banner if branch failed or if registration banner is disabled
  return appBannerFlag.value && (branchFailed.value || !registrationBannerFlag.value);
});

const branchLoading = computed(() => {
  return branch.initState === "pending";
});
const shouldShowRegistrationBanner = computed(() => {
  // delay showing banner until branch is loaded if app banner might be shown
  return registrationBannerFlag.value && (!branchLoading.value || !appBannerFlag.value);
});

return { __sfc: true,props, appBannerFlag, registrationBannerFlag, branch, branchFailed, shouldShowAppBanner, branchLoading, shouldShowRegistrationBanner }
}

})